import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import style from './style'
import { COLORS } from '~/themes/common'

const Icon = ({
  classes,
  name,
  size,
  color,
  className,
  style,
  useBackgroundImg,
}) => (
  <div
    className={clsx(classes.icon, size, className)}
    style={{
      color,
      maskImage: `url(/icons/${name}.svg)`,
      WebkitMaskImage: `url(/icons/${name}.svg)`,
      backgroundColor: color,
      maskSize: 'contain',
      WebkitMaskSize: 'contain',
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      maskPosition: 'center',
      WebkitMaskPosition: 'center',
      display: 'inline-block',
      width: typeof size === 'number' && size,
      height: typeof size === 'number' && size,
      ...(useBackgroundImg && {
        backgroundImage: `url(/icons/${name}.svg)`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
      }),
      ...style,
    }}
  />
)

Icon.defaultProps = {
  size: 'medium',
  color: COLORS.gray.darkGray,
  className: '',
  style: {},
  useBackgroundImg: false,
}

Icon.propTypes = {
  classes: PropTypes.shape().isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'medium', 'large']),
    PropTypes.number,
  ]),
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape(),
  useBackgroundImg: PropTypes.bool,
}

export default withStyles(style)(Icon)
